import React from "react";
import { createUseStyles } from "react-jss";
import { variables } from "../../variables";

const styles = createUseStyles({
  FlightEngine: {
    display: "grid",
    overflow: "hidden",
    placeContent: "center",
  },
  title: {
    display: "grid",
    textAlign: "center",
    height: "100%",
    alignItems: "end",
    padding: variables.normal_gap,
  },
});
const Monitoring = () => {
  const classes = styles();
  return (
    <div className={classes.FlightEngine}>
      <div className={classes.title}>
        <h1>Monitoring</h1>
      </div>
    </div>
  );
};

export default Monitoring;
